import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: 'offlineFirst',
    },
    queries: {
      staleTime: Infinity,
      gcTime: 60 * 60 * 1000,
      suspense: true,
      networkMode: 'offlineFirst',
    },
  },
});
